import React from "react";
import ProfileManager from "../ProfileManager";
import ApiErrorBoundary from "../components/ApiErrorBoundary";
import type { Location } from "../types";
import { useLang } from "../LangContext";

interface Props {
  token: string;
  onClose: () => void;
  onDurationOptionsChange: (opts: number[]) => void;
  onDefaultDurationChange: (value: number | null) => void;
  onCustomPublicIdChange: (slug: string | null) => void;
  onLocationsChange: (data: Location[] | null) => void;
  onLogoChange: (url: string | null) => void;
}

export default function ProfileOverlay({
  token,
  onClose,
  onDurationOptionsChange,
  onDefaultDurationChange,
  onCustomPublicIdChange,
  onLocationsChange,
  onLogoChange,
}: Props) {
  const { t } = useLang();

  return (
    <div className="profile-overlay">
      <div className="profile-overlay-backdrop" onClick={onClose} />
      <div className="profile-overlay-content">
        <div className="profile-overlay-header">
          <h3>{t.editProfileHeading}</h3>
          <button
            className="close-button"
            onClick={onClose}
            aria-label={t.closeProfileEditor}
          >
            ×
          </button>
        </div>
        <ApiErrorBoundary>
          <ProfileManager
            token={token}
            onDurationOptionsChange={onDurationOptionsChange}
            onDefaultDurationChange={onDefaultDurationChange}
            onCustomPublicIdChange={onCustomPublicIdChange}
            onLocationsChange={onLocationsChange}
            onLogoChange={onLogoChange}
          />
        </ApiErrorBoundary>
      </div>
    </div>
  );
}
